const initialState = {
    selectedAlertRow:null
};
export default initialState;